import { createContext, useContext, useState, useEffect, type ReactNode } from 'react'
import { featureFlagApiService } from '../services/featureFlagApiService'

interface FeatureFlagContextType {
  flags: Record<string, boolean>
  isLoading: boolean
}

const FeatureFlagContext = createContext<FeatureFlagContextType | undefined>(undefined)

export function FeatureFlagProvider({ children }: { children: ReactNode }) {
  const [flags, setFlags] = useState<Record<string, boolean>>({})
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    featureFlagApiService
      .getFeatureFlags()
      .then(setFlags)
      .catch(() => setFlags({}))
      .finally(() => setIsLoading(false))
  }, [])

  return (
    <FeatureFlagContext.Provider value={{ flags, isLoading }}>
      {children}
    </FeatureFlagContext.Provider>
  )
}

export function useFeatureFlagContext(): FeatureFlagContextType {
  const ctx = useContext(FeatureFlagContext)
  if (!ctx) throw new Error('useFeatureFlagContext must be used within FeatureFlagProvider')
  return ctx
}
